"use strict";

var _interopRequireDefault = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _CreateARecord = _interopRequireDefault(require("./components/CreateARecord.vue"));
var _PushMessageCreation = _interopRequireDefault(require("./components/PushMessageCreation.vue"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    CreateARecord: _CreateARecord.default,
    PushMessageCreation: _PushMessageCreation.default
  },
  data: function data() {
    return {
      activeName: 'first'
    };
  },
  methods: {
    handleClick: function handleClick(tab, event) {
      console.log(tab, event);
    }
  }
};